import { Box, Container, Hide, Layout } from 'pcln-design-system'
import React from 'react'
import styled from 'styled-components'
import { StyledHeroImage } from '../HeroModule.style'
import { getHeroMinHeights } from '../utils/utils'
import OverlayText from './OverlayText/OverlayText'

const StyledHero = styled(StyledHeroImage)`
  &&& {
    align-items: ${(props) => (props.alignItems === 'center' ? 'center' : 'flex-start')};
    background-position: ${(props) => props.imageBackgroundFocus};
    display: flex;
    justify-content: center;
    min-height: ${(props) => getHeroMinHeights(props.minHeight)[1]};

    @media only screen and (max-width: 768px) {
      min-height: ${(props) => getHeroMinHeights(props.minHeight)[0]};
      padding-left: 0px;
      padding-right: 0px;
    }
  }
`

function HeroFullModule(props) {
  const {
    heading,
    subheading,
    backgroundImage,
    heightDisplayOptions,
    overlineImage,
    overline,
    overlineImageHeightDisplayOptions,
    overlineImagePosition,
    imageGradient,
    sponsoredByImage,
    companionTout,
    searchForms,
    children,
    alignItems,
    textColor,
    imageBackgroundFocus = 'center',
  } = props

  const isToutAvailable = companionTout ? true : false

  if (children) {
    return (
      <StyledHero
        image={backgroundImage.url}
        alt={backgroundImage.altText}
        imageGradient={imageGradient}
        isToutAvailable={isToutAvailable}
        minHeight={heightDisplayOptions}
        imageBackgroundFocus={imageBackgroundFocus}
        {...props}
      >
        {children}
      </StyledHero>
    )
  }

  return (
    <StyledHero
      image={backgroundImage.url}
      alt={backgroundImage.altText}
      imageGradient={imageGradient}
      isToutAvailable={isToutAvailable}
      minHeight={heightDisplayOptions}
      alignItems={alignItems}
      imageBackgroundFocus={imageBackgroundFocus}
      {...props}
    >
      <Container size='lg' py={[2, null, null, 4]}>
        <Layout
          variation={isToutAvailable ? ['100', null, null, '100', '66-33'] : '100'}
          gap={'lg'}
          rowGap={'lg'}
        >
          <OverlayText
            heading={heading}
            subheading={subheading}
            overlineImage={overlineImage}
            overline={overline}
            sponsoredByImage={sponsoredByImage}
            isToutAvailable={isToutAvailable}
            maxOverlineImageHeight={overlineImageHeightDisplayOptions}
            overlineImagePosition={overlineImagePosition}
            textColor={textColor}
          />
          {isToutAvailable && (
            <Hide xs sm md margin='auto'>
              <Box maxHeight='inherit'>
                {/* companionTout can be any React Component */}
                {companionTout}
              </Box>
            </Hide>
          )}
        </Layout>
        {searchForms && (
          <Box my={[3, 3, 4]} mx={[null, null, 2, 2, 5]}>
            {/* searchForm can be any React Component */}
            {searchForms}
          </Box>
        )}
      </Container>
    </StyledHero>
  )
}

export default HeroFullModule
